import qs from 'qs';
import { LocalStorageService } from '../../services/local-storage-service';

const LOCAL_STORAGE_STRING = 'ssTestMode';

let testMode;
const init = () => {
  const queryParams = qs.parse(window.location.search.substring(1));
  if (queryParams.test === 'true') {
    testMode = true;
    LocalStorageService.setItem(LOCAL_STORAGE_STRING, 'true');
    return;
  }
  const localStorageValue = LocalStorageService.getItem(LOCAL_STORAGE_STRING, false);
  if (localStorageValue === true) {
    testMode = true;
  }
};

export const isInTestMode = () => {
  return !!testMode;
};

window.setTestMode = (mode) => {
  testMode = !!mode;
  if (testMode) {
    LocalStorageService.setItem(LOCAL_STORAGE_STRING, 'true');
  }
};

init();
